<template>
  <div id="formulario-edit-info">
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vx-card>
        <div class="vx-row mb-4">            
            <div class="vx-col w-1/2">
                <vs-input class="w-full mt-4" :label="$t('TelaDivisao_lNome')" v-model="data_local.nome" name="nome" />                
            </div>     
        </div>
       
        <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">                    
            <vs-button class="ml-auto mt-2" size="small" @click="gravar" :disabled="!temPermissaoGravar && !temCapacidadeMaster" color="success">{{ $t('Btn_Gravar') }}</vs-button>
            <vs-button class="ml-4 mt-2" size="small" @click="excluir" :disabled="!temPermissaoGravar && !temCapacidadeMaster" v-show="isDeletable" color="danger">{{ $t('Btn_Excluir') }}</vs-button>            
            <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>             
        </div>
        </div>
    </vx-card>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import "vue-swatches/dist/vue-swatches.css"

const URL_SERVLET = "/rest/DivisaoGrupoVeiculo/";
const NAME_ROUTE_SEARCH = "configuracao-divisao-controle-acesso";

export default {    
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
            return {nome: ''}
       }
    },
  },
  data() {
    return {            
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal))
    }
  },    
  mounted() {
      if (this.registroOriginal.hasOwnProperty('id')) {          
          this.findById();  
      } 
  },
  computed: { 
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },    
    validateForm() {
      return !this.errors.any()
    },    
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }
  },
  methods: {     
    findById() {
        const params = new URLSearchParams();        
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "Recuperar", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.DivisaoGrupoVeiculo;                 
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        const params = new URLSearchParams();        
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "Remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                if (response.data.Resultado.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 

            const params = new URLSearchParams();        
            
            if (this.data_local.hasOwnProperty("id")) {
                params.append('id', this.data_local.id);               
            }  
               
            params.append('nome', this.data_local.nome);      
                 
            axios.post(URL_SERVLET+ "Gravar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {                    
                    if (response.data.Resultado.hasOwnProperty("error")) {
                            this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                   
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.nome) {
            this.errorsValidacao.push(this.$t('TelaDivisao_lNome') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },         
  }
}
</script>